import { IconPlus } from "@tabler/icons-react";
import styles from "./BankConnectionGroup.module.css";
import BankCard from "./BankCard";
import Text from "../UI/Text";
import Button from "../UI/Button";
import { type Bank } from "../../models/bank";

interface BankConnectionGroupProps {
  connectionId: string;
  banks: Bank[];
  onLinxoReconnect: (
    connectionId: string | null,
    channelDefinitionId: string | null,
  ) => void;
  onManageAccounts: (connectionId: string, channelDefinitionId: string) => void;
  onShowTransactions: (bank: Bank) => void;
}

export default function BankConnectionGroup({
  banks,
  onLinxoReconnect,
  onManageAccounts,
  onShowTransactions,
}: BankConnectionGroupProps) {
  if (banks.length === 0) return null;

  const firstBank = banks[0];

  const handleAddAccount = () => {
    if (firstBank.connection_id && firstBank.channel_definition_id) {
      onManageAccounts(
        firstBank.connection_id,
        firstBank.channel_definition_id,
      );
    }
  };

  return (
    <div>
      <div className={styles.header}>
        <Text as="h3" variant="deca" weight="medium">
          {firstBank.bank_metadata?.name ?? firstBank.nom ?? "Compte"}
        </Text>
        <Button variant="secondary" onClick={handleAddAccount}>
          <IconPlus size={16} />
          Ajouter un compte supplémentaire
        </Button>
      </div>
      <div className={styles.cardsRow}>
        {banks.map((bank) => (
          <BankCard
            key={bank.id}
            bank={bank}
            onLinxoReconnect={onLinxoReconnect}
            onManageAccounts={onManageAccounts}
            onShowTransactions={onShowTransactions}
          />
        ))}
      </div>
    </div>
  );
}
